module.exports = __webpack_public_path__ + "media/images/icon-booster-05e3bb88f909f8ea120de579f1bffa49.svg";